/*!
 * REPX Spin & Win (assets/repx-spin-wheel.js)
 * Loaded by sections/repx-spin-wheel.liquid.
 *
 * Security: this file never decides the reward and holds no API keys.
 * The REPX server draws the reward and creates the Shopify code; this file
 * only animates the wheel to the segment the server returns.
 * (Demo spins exist only inside the Shopify theme editor when no server URL is set.)
 */
(function () {
  'use strict';

  var SVGNS = 'http://www.w3.org/2000/svg';
  var KEYS = {
    did: 'repx_spin_did',
    result: 'repx_spin_result_v1',
    seen: 'repx_spin_seen_v1',
    attr: 'repx_spin_attr_v1',
    conf: 'repx_spin_conf_v1',
    session: 'repx_spin_session'
  };
  var MSG = {
    invalid_phone: 'Enter a valid Pakistani mobile number, e.g. 0300 1234567.',
    consent_required: 'Please agree to receive your reward on WhatsApp.',
    rate_limited: 'Too many attempts. Please wait a few minutes and try again.',
    device_limit: 'This device has already been used for a spin. One spin per customer.',
    captcha_failed: 'Please complete the security check and try again.',
    otp_invalid: 'That code is not right. Please check WhatsApp and try again.',
    otp_expired: 'That code has expired. Tap "Resend code".',
    otp_attempts: 'Too many wrong codes. Please request a new code.',
    otp_send_failed: "We couldn't send a code to this WhatsApp number. Please check the number.",
    token_invalid: 'Your spin session expired. Please enter your number again.',
    campaign_inactive: "The REPX Reward Wheel isn't running right now.",
    network: 'Connection problem. Please check your internet and try again.',
    not_configured: 'Spin & Win is not connected yet.',
    discount_failed: "We couldn't create your code just now. Please try again in a moment.",
    resend_limited: 'Your reward was just sent. Please wait a little before resending.',
    resend_sent: 'Sent! Check your WhatsApp chats.',
    default: 'Something went wrong. Please try again.'
  };

  /* ------------------------------------------------------------------ utils */
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function cookieGet(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cookieSet(name, value, days) {
    try {
      document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + Math.round(days * 86400) + ';SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
    } catch (e) {}
  }
  function uuid() {
    if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    var b = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(b);
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function mod(a, n) { return ((a % n) + n) % n; }
  function hexToRgb(hex) {
    var m = String(hex || '').replace('#', '');
    if (m.length === 3) m = m.replace(/(.)/g, '$1$1');
    var n = parseInt(m, 16);
    if (isNaN(n) || m.length !== 6) return [201, 251, 19];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function mix(hex, withRgb, amount) {
    var a = hexToRgb(hex);
    return 'rgb(' + a.map(function (v, i) { return Math.round(v + (withRgb[i] - v) * amount); }).join(',') + ')';
  }
  function phoneDigits(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.indexOf('0092') === 0) d = '0' + d.slice(4);
    else if (d.indexOf('92') === 0 && d.length >= 12) d = '0' + d.slice(2);
    if (d.charAt(0) === '3') d = '0' + d;
    return d.slice(0, 11);
  }
  function phoneDisplay(d) { return d.length > 4 ? d.slice(0, 4) + ' ' + d.slice(4) : d; }
  function phoneValid(d) { return /^03\d{9}$/.test(d); }
  function phoneMasked(d) { return d ? d.slice(0, 4) + ' •••' + d.slice(-4) : ''; }

  function deviceId() {
    var id = null;
    try { id = localStorage.getItem(KEYS.did); } catch (e) {}
    if (!id) id = cookieGet(KEYS.did);
    if (!id || !/^[a-z0-9-]{16,64}$/i.test(id)) id = uuid();
    try { localStorage.setItem(KEYS.did, id); } catch (e) {}
    cookieSet(KEYS.did, id, 400);
    return id;
  }

  function attribution() {
    var a = lsGet(KEYS.attr) || {};
    var first = a.first || {}, last = a.last || {};
    var q = new URLSearchParams(location.search);
    function pick(k) { return (q.get(k) || last[k] || first[k] || '').slice(0, 200); }
    return {
      utm_source: pick('utm_source'),
      utm_medium: pick('utm_medium'),
      utm_campaign: pick('utm_campaign'),
      utm_content: pick('utm_content'),
      utm_term: pick('utm_term'),
      fbclid: pick('fbclid'),
      ttclid: pick('ttclid'),
      gclid: pick('gclid'),
      referrer: (last.referrer || first.referrer || '').slice(0, 300),
      landing_page: (last.landing_page || first.landing_page || location.pathname).slice(0, 300),
      first_source: (first.utm_source || first.referrer || '').slice(0, 200),
      page: location.pathname.slice(0, 300)
    };
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    var root = document.getElementById('RepxSpin');
    var dlg = document.getElementById('RepxSpinDialog');
    var cfgEl = document.getElementById('RepxSpinConfig');
    if (!root || !dlg || !cfgEl || root.getAttribute('data-ready') === '1') return;
    root.setAttribute('data-ready', '1');

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
    cfg.text = cfg.text || {};

    var API = String(cfg.apiUrl || '').replace(/\/+$/, '');
    var LOCAL = cfg.mode === 'local';
    var DEMO = !!cfg.demo && !LOCAL;
    var DESIGN = !!cfg.designMode;
    var PREVIEW = DEMO || DESIGN;
    var REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    var LIME = /^#[0-9a-f]{3,6}$/i.test(cfg.lime || '') ? cfg.lime : '#C9FB13';
    var SHOP_URL = /^\/(?!\/)/.test(cfg.shopUrl || '') ? cfg.shopUrl : '/collections/all';

    function $(sel, el) { return (el || dlg).querySelector(sel); }
    function $$(sel, el) { return Array.prototype.slice.call((el || dlg).querySelectorAll(sel)); }

    var el = {
      card: $('.rsw-card'),
      wheel: $('[data-rsw-wheel]'),
      body: $('.rsw-wheel__body'),
      rim: $('[data-rsw-rim]'),
      disc: $('[data-rsw-disc]'),
      hub: $('[data-rsw-hub]'),
      pointer: $('[data-rsw-pointer]'),
      form: $('[data-rsw-form]'),
      phone: $('[data-rsw-phone]'),
      unlock: $('[data-rsw-unlock]'),
      error: $('[data-rsw-error]'),
      captcha: $('[data-rsw-captcha]'),
      sub: $('[data-rsw-sub]'),
      campaign: $('[data-rsw-campaign]'),
      otpForm: $('[data-rsw-otp-form]'),
      otp: $('[data-rsw-otp]'),
      otpError: $('[data-rsw-otp-error]'),
      otpPhone: $('[data-rsw-otp-phone]'),
      otpResend: $('[data-rsw-otp-resend]'),
      verify: $('[data-rsw-verify]'),
      spin: $('[data-rsw-spin]'),
      spinError: $('[data-rsw-spin-error]'),
      resultTitle: $('[data-rsw-result-title]'),
      resultEyebrow: $('[data-rsw-result-eyebrow]'),
      resultText: $('[data-rsw-result-text]'),
      codeWrap: $('[data-rsw-code-wrap]'),
      code: $('[data-rsw-code]'),
      codeMeta: $('[data-rsw-code-meta]'),
      actions: $('[data-rsw-actions]'),
      copy: $('[data-rsw-copy]'),
      copyLabel: $('[data-rsw-copy-label]'),
      shop: $('[data-rsw-shop]'),
      waNote: $('[data-rsw-wa-note]'),
      again: $('[data-rsw-again]'),
      resend: $('[data-rsw-resend]'),
      resendMsg: $('[data-rsw-resend-msg]'),
      closedText: $('[data-rsw-closed-text]'),
      demoBadge: $('[data-rsw-demo]'),
      fab: root.querySelector('[data-rsw-open]')
    };
    var consentText = (($('.rsw-consent') || {}).textContent || '').trim();

    var state = {
      segments: normalizeSegments(cfg.segments),
      layoutVersion: null,
      campaignId: null,
      active: true,
      unlockToken: null,
      otpId: null,
      phone: '',
      spinning: false,
      rotation: 0,
      result: null,
      isOpen: false,
      step: 'form',
      numberTracked: false,
      tsWidget: null,
      tsToken: null,
      lastFocus: null
    };

    /* ------------------------------------------------------------ analytics */
    function track(name, data) {
      var payload = { campaign: state.campaignId || 'spin-win', source: (attribution().utm_source || 'direct') };
      if (data) for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k];
      if (DEMO) payload.preview = true;
      try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('repx:' + name, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, repx_spin: payload }); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', name, payload);
          if (name === 'spin_unlocked') window.fbq('track', 'Lead', { content_name: 'REPX Spin & Win' });
        }
      } catch (e) {}
      try {
        if (window.ttq && typeof window.ttq.track === 'function') {
          window.ttq.track(name, payload);
          if (name === 'spin_unlocked') window.ttq.track('SubmitForm', { content_name: 'REPX Spin & Win' });
        }
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('repx:spin', { detail: { name: name, data: payload } })); } catch (e) {}
    }

    /* ------------------------------------------------------------------ API */
    function api(path, body, timeoutMs) {
      if (DEMO) return demoApi(path, body);
      if (LOCAL) return localApi(path, body);
      if (!API) return Promise.resolve({ ok: false, error: 'not_configured' });
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, timeoutMs || 15000) : null;
      var init = {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json' },
        credentials: API.charAt(0) === '/' ? 'same-origin' : 'omit',
        cache: 'no-store'
      };
      if (ctrl) init.signal = ctrl.signal;
      if (body) { init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(body); }
      return fetch(API + path, init).then(function (r) {
        return r.json().catch(function () { return { ok: false, error: 'bad_response' }; }).then(function (j) {
          j = j || {};
          j.httpStatus = r.status;
          return j;
        });
      }, function () {
        return { ok: false, error: 'network' };
      }).then(function (j) { if (timer) clearTimeout(timer); return j; });
    }

    /* No-server mode: the reward is chosen in the browser from the odds in the theme settings. The code is one of the
       random codes that were added to the Shopify discounts in bulk (same generator as the pool, so every code exists). */
    function rand() { try { var a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] / 4294967296; } catch (e) { return Math.random(); } }
    function localExpiry(d) { d = String(d || '').trim(); if (d.length !== 10) return null; var t = new Date(d + 'T23:59:59+05:00'); return isNaN(t.getTime()) ? null : t.toISOString(); }
    function poolCode(percent, k) {
      var P = cfg.local || {}, size = Math.max(1, Number(P.poolSize) || 1000), seed = ((Number(P.poolSeed) || 20261021) + percent * 7919) | 0;
      var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', seen = {}, made = -1, code = '', a = seed;
      function next() { a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }
      k = Math.abs(k | 0) % size;
      while (made < k) {
        var s = '';
        for (var i = 0; i < 5; i++) s += alphabet.charAt(Math.floor(next() * 32));
        if (seen[s]) continue;
        seen[s] = 1; made++; code = s;
      }
      return String(P.codePrefix || 'REPX').toUpperCase() + percent + '-' + code;
    }
    function storeNumber(r) {
      if (!LOCAL || PREVIEW || !state.phone || !r.code) return;
      try {
        var P = cfg.local || {}, digits = state.phone, fd = new URLSearchParams();
        fd.set('form_type', 'customer'); fd.set('utf8', String.fromCharCode(10003));
        fd.set('contact[email]', '92' + digits.slice(1) + '@' + (P.emailDomain || 'spin.repx.pk'));
        fd.set('contact[first_name]', 'Spin & Win');
        fd.set('contact[last_name]', phoneDisplay(digits));
        fd.set('contact[tags]', 'spin-win,spin-win-' + (r.campaignId || 'local') + ',spin-' + r.percent + ',spinwin-code-' + r.code);
        fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' }, keepalive: true }).catch(function () {});
      } catch (e) {}
    }
    function localApi(path) {
      var L = cfg.local || {}, odds = L.odds || {}, mins = L.minOrder || {};
      var campaignId = cfg.localCampaignId || 'local';
      return new Promise(function (resolve) {
        setTimeout(function () {
          var segs = state.segments;
          if (path === '/config') return resolve({ ok: true, active: true, campaign: { id: campaignId }, segments: segs, layoutVersion: 'local' });
          if (path === '/unlock') return resolve({ ok: true, status: 'unlocked', unlockToken: 'local-' + uuid(), segments: segs, layoutVersion: 'local' });
          if (path === '/resend') return resolve({ ok: true });
          if (path !== '/spin') return resolve({ ok: false, error: 'default' });
          var pool = [], total = 0;
          segs.forEach(function (s, i) {
            var w = s.type === 'percent' ? Number(odds[s.id]) || 0 : 0;
            if (w > 0) { pool.push({ i: i, w: w }); total += w; }
          });
          if (!total) return resolve({ ok: false, error: 'not_configured' });
          var r = rand() * total, pick = pool[pool.length - 1];
          for (var j = 0; j < pool.length; j++) { r -= pool[j].w; if (r < 0) { pick = pool[j]; break; } }
          var seg = segs[pick.i];
          resolve({ ok: true, result: { spinId: 'local-' + Date.now().toString(36), segmentIndex: pick.i, prizeId: seg.id, type: 'percent', percent: seg.percent, jackpot: seg.percent >= 50, code: poolCode(seg.percent, Math.floor(rand() * 1e9)), expiresAt: localExpiry(L.expiresAt), minOrder: Number(mins[seg.id]) || 0, whatsapp: 'off', campaignId: campaignId } });
        }, path === '/spin' ? 700 : 350);
      });
    }

    /* Theme-editor preview only: a fake server so the design can be checked before the
       real REPX server is connected. Never used on the live store. */
    function demoApi(path) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          if (path === '/config') return resolve({ ok: true, active: true, campaign: { id: 'preview' }, segments: state.segments, layoutVersion: 'preview' });
          if (path === '/unlock') return resolve({ ok: true, status: 'unlocked', unlockToken: 'preview', segments: state.segments, layoutVersion: 'preview' });
          if (path === '/resend') return resolve({ ok: true });
          if (path === '/spin') {
            var odds = { 10: 30, 15: 25, 20: 22, 30: 13, 40: 7, 50: 3 };
            var pool = [];
            state.segments.forEach(function (s, i) { var w = s.type === 'percent' ? (odds[s.percent] || 0) : 0; if (w) pool.push({ i: i, w: w }); });
            var total = pool.reduce(function (t, p) { return t + p.w; }, 0), r = Math.random() * total, pick = pool[0];
            for (var j = 0; j < pool.length; j++) { r -= pool[j].w; if (r < 0) { pick = pool[j]; break; } }
            var seg = state.segments[pick.i];
            return resolve({ ok: true, result: { spinId: 'preview', segmentIndex: pick.i, prizeId: seg.id, type: 'percent', percent: seg.percent, jackpot: seg.percent >= 50, code: 'PREVIEW-' + seg.percent, expiresAt: new Date(Date.now() + 72 * 3600e3).toISOString(), whatsapp: 'preview', campaignId: 'preview' } });
          }
          resolve({ ok: false, error: 'default' });
        }, path === '/spin' ? 900 : 400);
      });
    }

    /* ---------------------------------------------------------------- wheel */
    function normalizeSegments(list) {
      if (!Array.isArray(list) || list.length < 2) return [];
      return list.map(function (s) {
        return {
          id: String(s.id || ''),
          type: s.type === 'none' ? 'none' : 'percent',
          percent: Math.max(0, Math.min(100, parseInt(s.percent, 10) || 0)),
          color: ['lime', 'white', 'black'].indexOf(s.color) > -1 ? s.color : 'white',
          label: s.label ? String(s.label).slice(0, 40) : ''
        };
      });
    }
    function layoutKey(segs) { return segs.map(function (s) { return s.id + ':' + s.type + ':' + s.percent + ':' + s.color; }).join('|'); }

    function polar(r, deg) {
      var a = (deg - 90) * Math.PI / 180;
      return [Math.round((500 + r * Math.cos(a)) * 100) / 100, Math.round((500 + r * Math.sin(a)) * 100) / 100];
    }

    function rimSVG() {
      var s = '<svg viewBox="0 0 1000 1000" xmlns="' + SVGNS + '" focusable="false" aria-hidden="true"><defs>' +
        '<linearGradient id="rswRimG" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#77777e"/><stop offset=".16" stop-color="#2b2b2f"/><stop offset=".36" stop-color="#0e0e10"/><stop offset=".52" stop-color="#45454b"/><stop offset=".7" stop-color="#121214"/><stop offset=".86" stop-color="#3a3a3f"/><stop offset="1" stop-color="#0c0c0d"/></linearGradient>' +
        '<radialGradient id="rswBulbG"><stop offset="0" stop-color="#fffdf5"/><stop offset=".4" stop-color="#ffe7b0"/><stop offset=".75" stop-color="#e8a24c"/><stop offset="1" stop-color="#6b3d12"/></radialGradient>' +
        '<radialGradient id="rswRivetG" cx=".35" cy=".32" r=".8"><stop offset="0" stop-color="#ffe4c2"/><stop offset=".28" stop-color="#d09358"/><stop offset=".68" stop-color="#7a4517"/><stop offset="1" stop-color="#2a1404"/></radialGradient>' +
        '</defs>' +
        '<circle cx="500" cy="500" r="500" fill="url(#rswRimG)"/>' +
        '<circle cx="500" cy="500" r="497" fill="none" stroke="rgba(255,255,255,.28)" stroke-width="2.5"/>' +
        '<circle cx="500" cy="500" r="457" fill="#030303"/>' +
        '<circle cx="500" cy="500" r="459" fill="none" stroke="rgba(255,255,255,.14)" stroke-width="2"/>';
      for (var k = 0; k < 32; k++) {
        var p = polar(478, k * 11.25 + 5.625);
        if (k % 2 === 0) {
          s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="12.5" fill="url(#rswBulbG)"/>';
        } else {
          s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="10" fill="url(#rswRivetG)"/><circle cx="' + (p[0] - 3) + '" cy="' + (p[1] - 3.5) + '" r="2.6" fill="rgba(255,255,255,.75)"/>';
        }
      }
      return s + '</svg>';
    }

    function lightsSVG(phase) {
      var s = '<svg viewBox="0 0 1000 1000" xmlns="' + SVGNS + '" focusable="false" aria-hidden="true"><defs><radialGradient id="rswGlow' + phase + '"><stop offset="0" stop-color="rgba(255,250,235,1)"/><stop offset=".25" stop-color="rgba(255,226,160,.9)"/><stop offset=".6" stop-color="rgba(255,180,80,.28)"/><stop offset="1" stop-color="rgba(255,170,60,0)"/></radialGradient></defs>';
      for (var k = 0; k < 32; k += 2) {
        if ((k / 2) % 2 !== phase) continue;
        var p = polar(478, k * 11.25 + 5.625);
        s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="34" fill="url(#rswGlow' + phase + ')"/>';
      }
      return s + '</svg>';
    }

    function hubSVG() {
      var s = '<svg viewBox="0 0 300 300" xmlns="' + SVGNS + '" focusable="false" aria-hidden="true"><defs>' +
        '<linearGradient id="rswHubRing" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#9a9aa0"/><stop offset=".25" stop-color="#2c2c30"/><stop offset=".5" stop-color="#0d0d0f"/><stop offset=".75" stop-color="#4c4c52"/><stop offset="1" stop-color="#111113"/></linearGradient>' +
        '<radialGradient id="rswHubFace" cx=".38" cy=".3" r=".85"><stop offset="0" stop-color="#2f2f33"/><stop offset=".55" stop-color="#0d0d0e"/><stop offset="1" stop-color="#030303"/></radialGradient>' +
        '</defs><circle cx="150" cy="150" r="150" fill="url(#rswHubRing)"/><circle cx="150" cy="150" r="136" fill="url(#rswHubFace)"/>' +
        '<circle cx="150" cy="150" r="135" fill="none" stroke="rgba(255,255,255,.09)" stroke-width="2"/>';
      [0, 90, 180, 270].forEach(function (a) {
        var r = 119, rad = (a - 90) * Math.PI / 180, x = 150 + r * Math.cos(rad), y = 150 + r * Math.sin(rad);
        s += '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="8.5" fill="url(#rswRivetG)"/><circle cx="' + (x - 2.4).toFixed(1) + '" cy="' + (y - 2.6).toFixed(1) + '" r="2.2" fill="rgba(255,255,255,.8)"/>';
      });
      return s + '</svg>';
    }

    function discSVG(segs) {
      var n = segs.length, step = 360 / n, R = 500;
      var scale = Math.min(1.15, Math.sqrt(8 / n));
      var fsBig = Math.round(100 * scale), fsOff = Math.round(63 * scale), fsTry = Math.round(36 * scale);
      var rText = n <= 6 ? 310 : 336;
      var limeHi = mix(LIME, [255, 255, 255], 0.45), limeLo = mix(LIME, [0, 0, 0], 0.22);
      var s = '<svg viewBox="0 0 1000 1000" xmlns="' + SVGNS + '" focusable="false" aria-hidden="true"><defs>' +
        '<radialGradient id="rswSegLime" cx="500" cy="500" r="500" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="' + limeHi + '"/><stop offset=".55" stop-color="' + esc(LIME) + '"/><stop offset="1" stop-color="' + limeLo + '"/></radialGradient>' +
        '<radialGradient id="rswSegWhite" cx="500" cy="500" r="500" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#ffffff"/><stop offset=".7" stop-color="#f3f3f3"/><stop offset="1" stop-color="#d6d6d6"/></radialGradient>' +
        '<radialGradient id="rswSegBlack" cx="500" cy="500" r="500" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#2e2e31"/><stop offset=".6" stop-color="#151517"/><stop offset="1" stop-color="#050505"/></radialGradient>' +
        '</defs>';
      var wedges = '', flashes = '', labels = '';
      segs.forEach(function (seg, i) {
        var a0 = (i - 0.5) * step, a1 = (i + 0.5) * step;
        var p0 = polar(R, a0), p1 = polar(R, a1);
        var large = step > 180 ? 1 : 0;
        var d = 'M500 500L' + p0[0] + ' ' + p0[1] + 'A' + R + ' ' + R + ' 0 ' + large + ' 1 ' + p1[0] + ' ' + p1[1] + 'Z';
        var fill = seg.color === 'lime' ? 'url(#rswSegLime)' : seg.color === 'black' ? 'url(#rswSegBlack)' : 'url(#rswSegWhite)';
        var ink = seg.color === 'black' ? '#ffffff' : '#0a0a0a';
        wedges += '<path d="' + d + '" fill="' + fill + '" stroke="rgba(0,0,0,.22)" stroke-width="2"/>';
        flashes += '<path class="rsw-seg-flash" data-i="' + i + '" d="' + d + '" fill="#ffffff"/>';
        var c = polar(rText, i * step);
        var inner;
        if (seg.type === 'none') {
          inner = '<g transform="translate(0 -66)"><circle r="31" fill="none" stroke="' + ink + '" stroke-width="5.5"/><circle cx="-11" cy="-7" r="4.6" fill="' + ink + '"/><circle cx="11" cy="-7" r="4.6" fill="' + ink + '"/><path d="M-15 17Q0 3 15 17" fill="none" stroke="' + ink + '" stroke-width="5.5" stroke-linecap="round"/></g>' +
            '<text text-anchor="middle" y="12" font-size="' + fsTry + '" fill="' + ink + '" letter-spacing=".5">TRY AGAIN</text>' +
            '<text text-anchor="middle" y="' + (12 + Math.round(fsTry * 1.12)) + '" font-size="' + fsTry + '" fill="' + ink + '" letter-spacing=".5">NEXT TIME</text>';
        } else {
          inner = '<text text-anchor="middle" y="' + Math.round(fsBig * 0.12) + '" font-size="' + fsBig + '" fill="' + ink + '" letter-spacing="-4">' + seg.percent + '%</text>' +
            '<text text-anchor="middle" y="' + Math.round(fsBig * 0.12 + fsOff * 1.02) + '" font-size="' + fsOff + '" fill="' + ink + '" letter-spacing="1">OFF</text>';
        }
        labels += '<g class="rsw-seg-label" data-i="' + i + '"><g transform="translate(' + c[0] + ' ' + c[1] + ')">' + inner + '</g></g>';
      });
      return s + wedges + flashes + labels + '</svg>';
    }

    function renderStatic() {
      el.rim.innerHTML = rimSVG();
      var a = document.createElement('div'); a.className = 'rsw-lights'; a.innerHTML = lightsSVG(0);
      var b = document.createElement('div'); b.className = 'rsw-lights rsw-lights--b'; b.innerHTML = lightsSVG(1);
      el.rim.appendChild(a); el.rim.appendChild(b);
      el.hub.innerHTML = hubSVG();
      if (!el.body.querySelector('.rsw-gloss')) {
        var g = document.createElement('div');
        g.className = 'rsw-gloss';
        g.setAttribute('aria-hidden', 'true');
        g.style.cssText = 'position:absolute;inset:4.5%;border-radius:50%;pointer-events:none;z-index:2;' +
          'background:radial-gradient(70% 55% at 30% 16%,rgba(255,255,255,.2),rgba(255,255,255,0) 60%),radial-gradient(closest-side,rgba(0,0,0,0) 84%,rgba(0,0,0,.38) 100%);';
        el.body.insertBefore(g, el.hub.parentNode);
      }
    }

    function renderDisc() {
      el.disc.innerHTML = discSVG(state.segments);
      el.wheel.setAttribute('aria-label', 'REPX Reward Wheel: ' + state.segments.map(function (s) {
        return s.type === 'none' ? 'try again' : s.percent + '% off';
      }).join(', '));
    }

    function applySegments(list, version) {
      var segs = normalizeSegments(list);
      if (!segs.length) return;
      if (layoutKey(segs) !== layoutKey(state.segments) || !el.disc.firstChild) {
        state.segments = segs;
        renderDisc();
      }
      if (version) state.layoutVersion = version;
    }

    function setRotation(deg) {
      state.rotation = deg;
      el.disc.style.transform = 'rotate(' + deg.toFixed(3) + 'deg)';
    }

    /* ---------------------------------------------------- spin animation */
    var pointerSvg = el.pointer ? el.pointer.querySelector('svg') : null;
    var lastTick = 0;
    function tick(now) {
      if (now - lastTick < 55 || !pointerSvg) return;
      lastTick = now;
      if (pointerSvg.animate) {
        pointerSvg.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(-14deg)', offset: 0.35 }, { transform: 'rotate(0deg)' }], { duration: 130, easing: 'ease-out' });
      }
    }

    function Spinner() {
      var V = REDUCED ? 520 : 1100;            // cruise speed, deg/s
      var MIN_TRAVEL = REDUCED ? 360 : 1500;   // degrees travelled while slowing down
      var step = 360 / state.segments.length;
      var raf = 0, phase = 'windup', t0 = performance.now(), a0 = state.rotation, last = a0;
      var decel = null, done = null, tickIdx = Math.floor((a0 + step / 2) / step);

      function frame(now) {
        var angle;
        if (phase === 'windup') {
          var tw = (now - t0) / 1000, W = REDUCED ? 0 : 0.22;
          if (tw < W) { angle = a0 - 9 * Math.sin(Math.PI * tw / W); }
          else { phase = 'accel'; t0 = now; }
        }
        if (phase === 'accel') {
          var ta = (now - t0) / 1000, T = REDUCED ? 0.3 : 0.55;
          if (ta < T) { angle = a0 + (V / (2 * T)) * ta * ta; }
          else { phase = 'cruise'; a0 = a0 + V * T / 2 + V * (ta - T); t0 = now; }
        }
        if (phase === 'cruise') {
          angle = a0 + V * ((now - t0) / 1000);
          if (decel) startDecel(now, angle);
        }
        if (phase === 'decel') {
          var x = Math.min(1, (now - decel.t0) / decel.dur);
          var e = 1 - Math.pow(1 - x, 4); // ease-out quart: starts at speed V, creeps in at the end
          angle = decel.from + (decel.to - decel.from) * e;
          if (x >= 1) {
            setRotation(decel.to);
            cancelAnimationFrame(raf);
            phase = 'stopped';
            var cb = done; done = null;
            if (cb) cb();
            return;
          }
        }
        if (angle !== undefined) {
          setRotation(angle);
          last = angle;
          var idx = Math.floor((angle + step / 2) / step);
          if (idx !== tickIdx) { tickIdx = idx; tick(now); }
        }
        raf = requestAnimationFrame(frame);
      }

      function startDecel(now, angle) {
        var target;
        step = 360 / state.segments.length;
        if (decel.index == null) {
          target = angle + MIN_TRAVEL * 0.5;
        } else {
          var jitter = (Math.random() - 0.5) * step * 0.62;
          var wantMod = mod(-(decel.index * step) + jitter, 360);
          var base = angle + MIN_TRAVEL;
          target = base + mod(wantMod - mod(base, 360), 360);
        }
        decel.from = angle;
        decel.to = target;
        decel.t0 = now;
        decel.dur = Math.max(1200, Math.min(7200, 4 * (target - angle) / V * 1000));
        phase = 'decel';
      }

      raf = requestAnimationFrame(frame);
      return {
        landOn: function (index) {
          return new Promise(function (resolve) {
            decel = { index: index };
            done = resolve;
            if (phase === 'windup' || phase === 'accel') {
              /* the server answered very fast: keep spinning until cruise speed, then slow down */
            }
          });
        },
        stop: function () {
          return new Promise(function (resolve) { decel = { index: null }; done = resolve; });
        }
      };
    }

    /* ---------------------------------------------------------------- steps */
    function showStep(name) {
      $$('[data-rsw-step]').forEach(function (s) { s.hidden = s.getAttribute('data-rsw-step') !== name; });
      state.step = name;
      dlg.setAttribute('data-step', name);
      if (name === 'form') toggleCampaignText();
    }

    function setLoading(btn, on) {
      if (!btn) return;
      btn.classList.toggle('is-loading', !!on);
      btn.disabled = !!on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function setError(node, msg) {
      if (!node) return;
      node.textContent = msg || '';
      var form = node.closest('form');
      if (form) form.classList.toggle('has-error', !!msg);
    }

    function messageFor(res, fallbackKey) {
      var key = res && res.error;
      if (key === 'rate_limited' && res.retryAfter) return MSG.rate_limited;
      return MSG[key] || (res && res.message) || MSG[fallbackKey] || MSG.default;
    }

    function isOfflineVisitor() {
      var at = attribution();
      var src = (at.utm_source || '').toLowerCase(), med = (at.utm_medium || '').toLowerCase();
      return med === 'qr' || /gym|uni|university|campus|event|activation/.test(src);
    }

    function toggleCampaignText() {
      if (!el.campaign) return;
      var show = cfg.campaignMode === 'always' || (cfg.campaignMode === 'offline' && isOfflineVisitor());
      el.campaign.hidden = !show;
      if (el.sub) el.sub.hidden = show && cfg.campaignMode === 'offline';
    }

    /* ------------------------------------------------------------ open/close */
    function lockScroll(on) { document.documentElement.classList.toggle('rsw-lock', !!on); }

    function open(trigger) {
      if (state.isOpen || !dlg.isConnected) return;
      var stored = readResult();
      if (!state.active) {
        showStep('closed');
      } else if (stored) {
        showResult(stored, true);
      } else if (state.unlockToken) {
        showStep('ready');
      } else {
        showStep('form');
      }
      state.isOpen = true;
      state.lastFocus = document.activeElement;
      dlg.classList.remove('is-closing');
      lockScroll(true);
      if (!dlg.open) {
        if (typeof dlg.showModal === 'function') {
          try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); dlg.classList.add('rsw-fallback'); }
        } else { dlg.setAttribute('open', ''); dlg.classList.add('rsw-fallback'); }
      }
      dlg.scrollTop = 0;
      ssSet(KEYS.session, 1);
      if (!stored) lsSet(KEYS.seen, { ts: Date.now() });
      track('spin_popup_view', { trigger: trigger || 'button' });
      if (state.step === 'form') ensureTurnstile();
      var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
      focusEl(fine && state.step === 'form' ? el.phone : el.card);
    }

    function close() {
      if (!state.isOpen) return;
      state.isOpen = false;
      if (!readResult()) lsSet(KEYS.seen, { ts: Date.now() });
      dlg.classList.add('is-closing');
      setTimeout(function () {
        dlg.classList.remove('is-closing');
        if (dlg.open && typeof dlg.close === 'function') { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } }
        else dlg.removeAttribute('open');
        lockScroll(false);
        focusEl(state.lastFocus);
      }, REDUCED ? 0 : 200);
    }

    function focusEl(node) { if (node && node.focus) { try { node.focus({ preventScroll: true }); } catch (e) {} } }

    /* --------------------------------------------------------- Turnstile */
    function ensureTurnstile() {
      if (!cfg.turnstileSiteKey || DEMO || !el.captcha || state.tsWidget !== null) return;
      state.tsWidget = 'loading';
      el.captcha.hidden = false;
      var render = function () {
        try {
          state.tsWidget = window.turnstile.render(el.captcha, {
            sitekey: cfg.turnstileSiteKey,
            appearance: 'interaction-only',
            theme: 'dark',
            callback: function (t) { state.tsToken = t; },
            'expired-callback': function () { state.tsToken = null; },
            'error-callback': function () { state.tsToken = null; }
          });
        } catch (e) { state.tsWidget = null; }
      };
      if (window.turnstile) return render();
      window.__repxSpinTs = render;
      var sc = document.createElement('script');
      sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=__repxSpinTs';
      sc.async = true; sc.defer = true;
      document.head.appendChild(sc);
    }
    function captchaToken() {
      if (!cfg.turnstileSiteKey || DEMO) return Promise.resolve(null);
      ensureTurnstile();
      return new Promise(function (resolve) {
        var waited = 0;
        (function poll() {
          if (state.tsToken || waited > 10000) {
            var t = state.tsToken;
            state.tsToken = null;
            try { if (window.turnstile && state.tsWidget && state.tsWidget !== 'loading') window.turnstile.reset(state.tsWidget); } catch (e) {}
            return resolve(t);
          }
          waited += 150; setTimeout(poll, 150);
        })();
      });
    }

    /* --------------------------------------------------------- unlock flow */
    function unlockPayload() {
      return {
        phone: '+92' + state.phone.slice(1),
        deviceId: deviceId(),
        consent: true,
        consentText: consentText.slice(0, 300),
        attribution: attribution()
      };
    }

    function handleUnlock(res) {
      if (res && res.ok && res.status === 'unlocked' && res.unlockToken) {
        state.unlockToken = res.unlockToken;
        state.otpId = null;
        if (res.segments) applySegments(res.segments, res.layoutVersion);
        track('spin_unlocked', { otp: !!res.verified });
        showStep('ready');
        setError(el.spinError, '');
        el.spin.disabled = false;
        focusEl(el.spin);
        return;
      }
      if (res && res.ok && res.status === 'otp_sent') {
        state.otpId = res.otpId;
        if (el.otpPhone) el.otpPhone.textContent = phoneMasked(state.phone);
        el.otp.value = '';
        setError(el.otpError, '');
        showStep('otp');
        startResendTimer(res.resendIn || 30);
        focusEl(el.otp);
        return;
      }
      if (res && res.error === 'already_spun') { showStep('already'); setError(el.resendMsg, ''); return; }
      if (res && res.error === 'campaign_inactive') { state.active = false; showStep('closed'); return; }
      setError(state.step === 'otp' ? el.otpError : el.error, messageFor(res));
    }

    var resendTimer = 0;
    function startResendTimer(sec) {
      clearInterval(resendTimer);
      var left = Math.max(5, sec | 0);
      el.otpResend.disabled = true;
      el.otpResend.textContent = 'Resend code (' + left + 's)';
      resendTimer = setInterval(function () {
        left -= 1;
        if (left <= 0) { clearInterval(resendTimer); el.otpResend.disabled = false; el.otpResend.textContent = 'Resend code'; }
        else el.otpResend.textContent = 'Resend code (' + left + 's)';
      }, 1000);
    }

    function resetToForm() {
      state.unlockToken = null;
      state.otpId = null;
      clearInterval(resendTimer);
      showStep('form');
      setError(el.error, '');
      ensureTurnstile();
      focusEl(el.phone);
    }

    /* ------------------------------------------------------------- spin */
    function doSpin() {
      if (state.spinning || !state.unlockToken) return;
      state.spinning = true;
      el.spin.disabled = true;
      setError(el.spinError, '');
      dlg.classList.remove('is-won', 'is-jackpot');
      straighten(null);
      dlg.classList.add('is-spinning');
      track('spin_started', {});
      var token = state.unlockToken;
      var spinner = Spinner();
      api('/spin', { unlockToken: token, deviceId: deviceId(), attribution: attribution() }, 25000).then(function (res) {
        if (!res || !res.ok || !res.result) {
          return spinner.stop().then(function () { spinFailed(res); });
        }
        if (res.segments) applySegments(res.segments, res.layoutVersion);
        var r = res.result;
        r.campaignId = r.campaignId || state.campaignId;
        r.at = Date.now();
        state.unlockToken = r.nextUnlockToken || null;
        if (r.type !== 'none') saveResult(r);
        return spinner.landOn(r.segmentIndex).then(function () { finishSpin(r); });
      });
    }

    function spinFailed(res) {
      state.spinning = false;
      dlg.classList.remove('is-spinning');
      if (res && (res.error === 'already_spun' || res.error === 'device_limit')) { state.unlockToken = null; showStep('already'); return; }
      if (res && res.error === 'campaign_inactive') { state.active = false; showStep('closed'); return; }
      if (res && res.error === 'token_invalid') { setError(el.error, MSG.token_invalid); resetToForm(); return; }
      el.spin.disabled = false;
      setError(el.spinError, messageFor(res));
    }

    function finishSpin(r) {
      state.spinning = false;
      dlg.classList.remove('is-spinning');
      track('spin_completed', { reward_percent: r.percent || 0, prize_id: r.prizeId || '' });
      if (r.type === 'none') {
        showNoReward(r);
        return;
      }
      if (navigator.vibrate) { try { navigator.vibrate([18, 40, 18]); } catch (e) {} }
      showResult(r, false);
      track('discount_won', { reward_percent: r.percent, prize_id: r.prizeId || '', jackpot: !!r.jackpot });
      if (r.code) track('discount_code_generated', { reward_percent: r.percent, coupon: r.code });
      if (!DEMO && r.code) setCartAttributes(r);
      if (LOCAL) storeNumber(r);
    }

    function straighten(index) {
      $$('.rsw-seg-label', el.disc).forEach(function (g) { g.style.transform = ''; });
      $$('.rsw-seg-flash', el.disc).forEach(function (p) { p.classList.remove('is-on'); });
      if (index == null) return;
      var label = el.disc.querySelector('.rsw-seg-label[data-i="' + index + '"]');
      var flash = el.disc.querySelector('.rsw-seg-flash[data-i="' + index + '"]');
      var tilt = mod(state.rotation + 180, 360) - 180;
      if (label) label.style.transform = 'rotate(' + (-tilt).toFixed(2) + 'deg) scale(1.1)';
      if (flash) flash.classList.add('is-on');
    }

    function landInstantly(index) {
      var step = 360 / state.segments.length;
      setRotation(mod(-(index * step), 360));
    }

    function winTitle(r) {
      var tpl = (r.jackpot ? cfg.text.jackpot : cfg.text.win) || 'YOU WON [percent]% OFF!';
      var html = esc(tpl).replace('[percent]', String(r.percent));
      var hl = r.percent + '% OFF';
      var at = html.indexOf(hl);
      if (at > -1) html = html.slice(0, at) + '<span class="rsw-hl">' + hl + '</span>' + html.slice(at + hl.length);
      return html;
    }

    function formatExpiry(iso) {
      var d = iso ? new Date(iso) : null;
      if (!d || isNaN(d.getTime())) return '';
      var hours = Math.round((d.getTime() - Date.now()) / 3600e3);
      if (hours <= 0) return 'This code has expired';
      var when = d.toLocaleString('en-PK', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
      return 'Single use · valid until ' + when;
    }

    function showResult(r, restored) {
      if (r.prizeId && (!state.segments[r.segmentIndex] || state.segments[r.segmentIndex].id !== r.prizeId)) {
        for (var i = 0; i < state.segments.length; i++) if (state.segments[i].id === r.prizeId) { r.segmentIndex = i; break; }
      }
      var seg = typeof r.segmentIndex === 'number' && state.segments[r.segmentIndex];
      if (restored && seg) { landInstantly(r.segmentIndex); }
      dlg.classList.add('is-won');
      dlg.classList.toggle('is-jackpot', !!r.jackpot);
      if (seg) straighten(r.segmentIndex);
      el.resultEyebrow.textContent = r.jackpot ? 'Jackpot reward' : 'Reward unlocked';
      el.resultTitle.innerHTML = winTitle(r);
      el.resultTitle.classList.toggle('rsw-title--jackpot', !!r.jackpot);
      if (r.jackpot && cfg.text.jackpotText) { el.resultText.textContent = cfg.text.jackpotText; el.resultText.hidden = false; }
      else el.resultText.hidden = true;
      el.codeWrap.hidden = !r.code;
      el.actions.hidden = false;
      el.code.textContent = r.code || '';
      var meta = formatExpiry(r.expiresAt);
      if (r.minOrder) meta += (meta ? ' · ' : '') + 'min. order Rs. ' + Number(r.minOrder).toLocaleString('en-PK');
      el.codeMeta.textContent = meta;
      el.copyLabel.textContent = el.copyLabel.getAttribute('data-label') || el.copyLabel.textContent;
      el.copy.classList.remove('rsw-copied');
      el.shop.setAttribute('href', r.code ? '/discount/' + encodeURIComponent(r.code) + '?redirect=' + encodeURIComponent(SHOP_URL) : SHOP_URL);
      el.waNote.hidden = LOCAL || !(r.whatsapp === 'queued' || r.whatsapp === 'sent' || restored);
      el.again.hidden = restored || !state.unlockToken;
      showStep('result');
      if (!restored && r.jackpot) burst();
      if (!restored) setTimeout(function () { try { el.resultTitle.scrollIntoView({ block: 'nearest', behavior: REDUCED ? 'auto' : 'smooth' }); } catch (e) {} }, 60);
    }

    function showNoReward(r) {
      dlg.classList.add('is-won');
      straighten(r.segmentIndex);
      el.resultEyebrow.textContent = 'So close';
      el.resultTitle.textContent = 'TRY AGAIN NEXT TIME';
      el.resultTitle.classList.remove('rsw-title--jackpot');
      el.resultText.textContent = state.unlockToken ? 'No reward on this spin, but you have another spin.' : 'No reward this time. Follow REPX for the next drop.';
      el.resultText.hidden = false;
      el.codeWrap.hidden = true;
      el.actions.hidden = true;
      el.waNote.hidden = true;
      el.again.hidden = !state.unlockToken;
      showStep('result');
    }

    function burst() {
      if (REDUCED || !el.body) return;
      var b = document.createElement('div');
      b.className = 'rsw-burst';
      for (var i = 0; i < 28; i++) {
        var p = document.createElement('i');
        var ang = Math.random() * Math.PI * 2, dist = 110 + Math.random() * 170;
        p.style.setProperty('--x', Math.round(Math.cos(ang) * dist) + 'px');
        p.style.setProperty('--y', Math.round(Math.sin(ang) * dist - 30) + 'px');
        p.style.setProperty('--r', Math.round(Math.random() * 540 - 270) + 'deg');
        p.style.animationDelay = (Math.random() * 0.15).toFixed(2) + 's';
        b.appendChild(p);
      }
      el.body.appendChild(b);
      setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 1700);
    }

    function saveResult(r) {
      lsSet(KEYS.result, {
        spinId: r.spinId, prizeId: r.prizeId, segmentIndex: r.segmentIndex, type: r.type, percent: r.percent,
        jackpot: !!r.jackpot, code: r.code, expiresAt: r.expiresAt, minOrder: r.minOrder || 0,
        whatsapp: r.whatsapp, campaignId: r.campaignId, at: r.at || Date.now(), preview: PREVIEW || undefined
      });
    }
    function readResult() {
      var r = lsGet(KEYS.result);
      if (!r || !r.code) return null;
      if (PREVIEW !== !!r.preview) return null;
      if (state.campaignId && r.campaignId && r.campaignId !== state.campaignId) return null;
      if (r.expiresAt && new Date(r.expiresAt).getTime() < Date.now() - 7 * 864e5) return null;
      return r;
    }

    function setCartAttributes(r) {
      try {
        var at = attribution();
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: {
            _repx_spin_code: r.code || '',
            _repx_spin_reward: r.percent ? r.percent + '%' : '',
            _repx_spin_id: r.spinId || '',
            _repx_spin_source: at.utm_source || (at.referrer ? 'referral' : 'direct'),
            _repx_spin_medium: at.utm_medium || '',
            _repx_spin_campaign: at.utm_campaign || ''
          } })
        }).catch(function () {});
      } catch (e) {}
    }

    function copyCode(text) {
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
        dlg.appendChild(ta);
        ta.select();
        try { ta.setSelectionRange(0, text.length); document.execCommand('copy'); } catch (e) {}
        dlg.removeChild(ta);
      }
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text).catch(fallback);
      fallback();
      return Promise.resolve();
    }

    /* ---------------------------------------------------- floating button */
    var GAP = parseInt(cfg.gap, 10) || 12;
    var follow = { root: null, toggle: null, observer: null, ticking: false };
    function findContact() {
      follow.root = document.querySelector('[data-rfc]');
      follow.toggle = follow.root ? follow.root.querySelector('[data-rfc-toggle]') : null;
      if (follow.root && !follow.observer && window.MutationObserver) {
        follow.observer = new MutationObserver(scheduleFollow);
        follow.observer.observe(follow.root, { attributes: true, attributeFilter: ['class', 'style'] });
      }
    }
    function clearFollow() {
      root.style.setProperty('--rsw-bottom', (parseInt(cfg.bottom, 10) || 86) + 'px');
      root.style.setProperty('--rsw-right', (parseInt(cfg.side, 10) || 20) + 'px');
      root.classList.remove('is-tucked');
    }
    function measureFollow() {
      follow.ticking = false;
      if (!follow.toggle || !document.body.contains(follow.toggle)) {
        if (follow.observer) { follow.observer.disconnect(); follow.observer = null; }
        findContact();
      }
      if (!follow.toggle) { clearFollow(); return; }
      var cs = window.getComputedStyle(follow.root);
      var r = follow.toggle.getBoundingClientRect();
      if (cs.display === 'none' || cs.visibility === 'hidden' || r.width === 0) { clearFollow(); return; }
      var w = root.offsetWidth || r.width;
      root.style.setProperty('--rsw-bottom', Math.round(window.innerHeight - r.top + GAP) + 'px');
      root.style.setProperty('--rsw-right', Math.round(window.innerWidth - r.right + (r.width - w) / 2) + 'px');
      root.classList.toggle('is-tucked', follow.root.classList.contains('is-open'));
    }
    function scheduleFollow() {
      if (!follow.ticking) { follow.ticking = true; window.requestAnimationFrame(measureFollow); }
    }

    function showFab() {
      if (!cfg.showButton) return;
      if (root.parentElement !== document.body) document.body.appendChild(root);
      root.hidden = false;
      scheduleFollow();
      setTimeout(scheduleFollow, 300);
    }

    /* ------------------------------------------------------- auto-open */
    function deviceAllowed() {
      var desktop = window.matchMedia && matchMedia('(min-width: 750px)').matches;
      return desktop ? cfg.showDesktop !== false : cfg.showMobile !== false;
    }
    function autoOpenAllowed() {
      if (cfg.autoOpen === 'off' || !state.active || readResult() || !deviceAllowed()) return false;
      if (/^\/(cart|checkout|account|challenge)/.test(location.pathname)) return false;
      if (cfg.autoOpen === 'always') return true;
      if (cfg.autoOpen === 'session') return !ssGet(KEYS.session);
      var seen = lsGet(KEYS.seen);
      return !(seen && seen.ts && Date.now() - seen.ts < (parseFloat(cfg.days) || 3) * 864e5);
    }
    function otherDialogOpen() {
      var open = document.querySelector('dialog[open]');
      return !!(open && open !== dlg);
    }
    function scheduleAutoOpen() {
      if (!autoOpenAllowed()) return;
      var elapsed = window.performance && performance.now ? performance.now() : 0;
      var wait = Math.max(600, (parseFloat(cfg.delay) || 0) * 1000 - elapsed);
      var tries = 0;
      setTimeout(function attempt() {
        if (state.isOpen || !autoOpenAllowed()) return;
        if (otherDialogOpen() && tries++ < 6) return setTimeout(attempt, 5000);
        open('auto');
      }, wait);
      if (cfg.exitIntent && window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var onOut = function (e) {
          if (e.relatedTarget || e.clientY > 8) return;
          document.removeEventListener('mouseout', onOut);
          if (!state.isOpen && autoOpenAllowed() && !otherDialogOpen()) open('exit_intent');
        };
        setTimeout(function () { document.addEventListener('mouseout', onOut); }, 4000);
      }
    }

    /* Spin & Win is off for shoppers (server unreachable or campaign paused): let the email welcome popup run again from the next page. */
    function wheelOff() { if (DESIGN) return; try { sessionStorage.setItem('repx_spin_off', '1'); if (sessionStorage.getItem('repx_spin_paused_wp')) { sessionStorage.removeItem('repx_spin_paused_wp'); sessionStorage.removeItem('rx_welcome_popup_skip'); } } catch (e) {} }

    /* --------------------------------------------------------- server config */
    function loadConfig() {
      if (DEMO) return demoApi('/config');
      if (LOCAL) return localApi('/config');
      var cached = ssGet(KEYS.conf);
      if (cached && cached.api === API && Date.now() - cached.ts < 5 * 60e3 && !DESIGN) return Promise.resolve(cached.data);
      return api('/config', null, 8000).then(function (res) {
        if (res && res.ok) ssSet(KEYS.conf, { api: API, ts: Date.now(), data: res });
        return res;
      });
    }

    /* ---------------------------------------------------------------- events */
    function bind() {
      el.fab.addEventListener('click', function () { open('button'); });
      $$('[data-rsw-close]').forEach(function (b) { b.addEventListener('click', close); });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      var downOnBackdrop = false;
      dlg.addEventListener('pointerdown', function (e) { downOnBackdrop = e.target === dlg; });
      dlg.addEventListener('click', function (e) { if (e.target === dlg && downOnBackdrop) close(); downOnBackdrop = false; });

      el.phone.addEventListener('input', function () {
        var atEnd = el.phone.selectionStart === el.phone.value.length;
        var d = phoneDigits(el.phone.value);
        if (atEnd) el.phone.value = phoneDisplay(d);
        setError(el.error, '');
        if (!state.numberTracked && phoneValid(d)) { state.numberTracked = true; track('whatsapp_number_entered', {}); }
      });
      el.phone.addEventListener('blur', function () { el.phone.value = phoneDisplay(phoneDigits(el.phone.value)); });

      el.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var d = phoneDigits(el.phone.value);
        if (!phoneValid(d)) { setError(el.error, MSG.invalid_phone); focusEl(el.phone); return; }
        state.phone = d;
        setLoading(el.unlock, true);
        captchaToken().then(function (token) {
          var body = unlockPayload();
          if (token) body.turnstileToken = token;
          return api('/unlock', body, 15000);
        }).then(function (res) {
          setLoading(el.unlock, false);
          handleUnlock(res);
        });
      });

      el.otp.addEventListener('input', function () {
        el.otp.value = el.otp.value.replace(/\D/g, '').slice(0, 6);
        setError(el.otpError, '');
        if (el.otp.value.length === 6) el.otpForm.requestSubmit ? el.otpForm.requestSubmit() : el.verify.click();
      });
      el.otpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = el.otp.value.replace(/\D/g, '');
        if (code.length !== 6) { setError(el.otpError, MSG.otp_invalid); return; }
        setLoading(el.verify, true);
        api('/verify', { otpId: state.otpId, code: code, deviceId: deviceId() }, 15000).then(function (res) {
          setLoading(el.verify, false);
          if (res && res.ok) res.verified = true;
          handleUnlock(res);
        });
      });
      el.otpResend.addEventListener('click', function () {
        el.otpResend.disabled = true;
        captchaToken().then(function (token) {
          var body = unlockPayload();
          body.resend = true;
          if (token) body.turnstileToken = token;
          return api('/unlock', body, 15000);
        }).then(handleUnlock);
      });
      $$('[data-rsw-change]').forEach(function (b) { b.addEventListener('click', resetToForm); });

      el.spin.addEventListener('click', doSpin);
      el.again.addEventListener('click', function () {
        if (!state.unlockToken) return resetToForm();
        dlg.classList.remove('is-won');
        straighten(null);
        showStep('ready');
        el.spin.disabled = false;
        focusEl(el.spin);
      });

      el.copyLabel.setAttribute('data-label', el.copyLabel.textContent);
      el.copy.addEventListener('click', function () {
        var code = el.code.textContent.trim();
        if (!code) return;
        copyCode(code).then(function () {
          el.copy.classList.add('rsw-copied');
          el.copyLabel.textContent = 'COPIED';
          setTimeout(function () { el.copy.classList.remove('rsw-copied'); el.copyLabel.textContent = el.copyLabel.getAttribute('data-label'); }, 2200);
        });
        track('copy_code_clicked', { coupon: code });
      });
      el.shop.addEventListener('click', function (e) {
        var href = el.shop.getAttribute('href');
        track('shop_now_clicked', { coupon: el.code.textContent.trim() });
        if (DESIGN) { e.preventDefault(); return; }
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        setTimeout(function () { window.location.href = href; }, 180);
      });
      $$('[data-rsw-shop-plain]').forEach(function (a) { a.addEventListener('click', function () { track('shop_now_clicked', {}); }); });

      el.resend.addEventListener('click', function () {
        if (!state.phone) { resetToForm(); return; }
        setLoading(el.resend, true);
        api('/resend', { phone: '+92' + state.phone.slice(1), deviceId: deviceId() }, 15000).then(function (res) {
          setLoading(el.resend, false);
          setError(el.resendMsg, res && res.ok ? MSG.resend_sent : messageFor(res));
        });
      });

      /* links to #spin-win open the popup (announcement bar, banners, QR landing pages) */
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href$="#spin-win"]') : null;
        if (!a) return;
        e.preventDefault();
        open('link');
      });

      window.addEventListener('scroll', scheduleFollow, { passive: true });
      window.addEventListener('resize', scheduleFollow);
      document.addEventListener('scroll', scheduleFollow, { passive: true, capture: true });
      document.addEventListener('click', function () { setTimeout(scheduleFollow, 50); setTimeout(scheduleFollow, 400); });
      setInterval(scheduleFollow, 1000);

      window.RepxSpinWin = { open: function () { open('api'); }, close: close };
    }

    /* ----------------------------------------------------------------- start */
    renderStatic();
    renderDisc();
    bind();
    if (DEMO && el.demoBadge) el.demoBadge.hidden = false;

    loadConfig().then(function (conf) {
      if (!conf || !conf.ok) {
        wheelOff();
        if (DESIGN) {
          state.active = true;
          showFab();
          if (el.closedText && API) el.closedText.textContent = "Can't reach the Spin & Win server at " + API + '.';
        }
        return;
      }
      state.campaignId = (conf.campaign && conf.campaign.id) || null;
      if (conf.segments) applySegments(conf.segments, conf.layoutVersion);
      state.active = conf.active !== false;
      if (!state.active) {
        if (el.closedText && conf.message) el.closedText.textContent = conf.message;
        if (!DESIGN) { wheelOff(); return; } // campaign not running: show nothing to shoppers
      }
      showFab();
      try { sessionStorage.removeItem('repx_spin_off'); } catch (e) {}
      var params = new URLSearchParams(location.search);
      if (!DESIGN && (params.get('spin') === '1' || location.hash === '#spin-win')) {
        setTimeout(function () { open(params.get('spin') === '1' ? 'url' : 'hash'); }, 400);
      } else if (!DESIGN) {
        scheduleAutoOpen();
      }
    });

    /* ---------------------------------------------------------- theme editor */
    if (DESIGN) {
      var sid = cfg.sectionId;
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === sid) open('editor'); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === sid) close(); });
      document.addEventListener('shopify:section:unload', function (e) {
        if (e.detail && e.detail.sectionId === sid) {
          try { if (dlg.open) dlg.close(); } catch (err) {}
          lockScroll(false);
          if (follow.observer) follow.observer.disconnect();
          if (root.parentNode) root.parentNode.removeChild(root);
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
